import classNames from 'classnames';
import { useCurrency } from 'hooks/useCurrency';
import PriceFormat from './PriceFormat';

const classesMap = {
  small: {
    container: 'h-10 px-2',
    actualPrice: 'text-2xl',
    oldPrice: 'pr-2 text-lg',
  },
  medium: {
    container: 'h-11 px-2',
    actualPrice: 'text-4xl',
    oldPrice: 'text-xl pr-2',
  },
  large: {
    container: 'flex-col md:flex-row h-[4.3rem] px-3',
    actualPrice: 'text-4xl md:text-6xl',
    oldPrice: 'text-xl md:text-3xl pr-2',
  },
};

export const PriceTag = ({ className, price, showDiscount, size, type }) => {
  const { code, defaultPrices } = useCurrency();
  const hasDiscount = showDiscount && price[code] < defaultPrices[type];
  const classes = classesMap[size];

  return (
    <div
      className={classNames(
        'flex justify-center bg-qw-yellow-200 text-black font-bold font-sans',
        classes.container,
        className
      )}
    >
      {hasDiscount && (
        <span className={classNames('line-through', classes.oldPrice)}>
          <PriceFormat value={defaultPrices[type]} />
        </span>
      )}
      <span
        className={classNames(
          'flex items-center whitespace-nowrap',
          classes.actualPrice
        )}
      >
        {price && <PriceFormat value={price?.[code]} />}
      </span>
    </div>
  );
};
